import { render } from "./config_sidebar.html?vue&type=template&id=3bcd1ce6&external"
import script from "./config_sidebar.js?vue&type=script&lang=js&external"
export * from "./config_sidebar.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__